/*
 * @Author: WYX
 * @Date: 2019/12/26
 * @LastEditTime: 2020-10-28 11:18:27
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editPagePart\editPageIsOriginal\original.js
 * @Description: 稿件选择原创或特殊稿
 */

angular.module('editPageOriginModule', []).directive('editPageOrigin', [
    'editingCenterService',
    'messagePublishService',
    function(editingCenterService, messagePublishService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/editPageIsOriginal/original.html',
            replace: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.data = {
                        originList: [
                            {
                                name: '内部原创',
                                value: '2',
                            },
                            {
                                name: '整合原创',
                                value: '1',
                            },
                            {
                                name: '特约稿',
                                value: '3',
                            },
                            {
                                name: '通讯员稿',
                                value: '4',
                            },
                            {
                                name: '报道组稿',
                                value: '5',
                            },
                            {
                                name: '其他',
                                value: '6',
                            },
                        ],
                        nopayment: null,
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    if ($scope.parentStatus.articleid) {
                        messagePublishService.subscribe(`${$scope.parentStatus.mediaName}ListInit`, function() {
                            initOrigin();
                        }, $scope);
                    } else {
                        initOrigin();
                    }
                    // messagePublishService.subscribe(
                    //     'hasGetEditInfo',
                    //     function(event, data) {
                    //         // 回显稿件来源
                    //         $scope.list.NEWSSOURCES = $scope.list.DOCSOURCENAME;
                    //     },
                    //     $scope
                    // );
                    // messagePublishService.subscribe(
                    //     'packageParams',
                    //     function(event, data) {
                    //         if (angular.isObject($scope.list.NEWSSOURCES)) {
                    //             $scope.list.DOCSOURCENAME = $scope.list.NEWSSOURCES;
                    //         } else {
                    //             $scope.list.DOCSOURCENAME = { SRCNAME: $scope.list.NEWSSOURCES, SOURCEID: '0' };
                    //         }
                    //     },
                    //     $scope
                    // );
                }

                /**
                 * [initOrigin description]初始化原创
                 * @return {[type]} [description]
                 */
                function initOrigin() {
                    if ($scope.status){
                        $scope.status.nopayment = true;   
                    }
                    for (var i = 0; i < $scope.data.originList.length; i++) {
                        if ($scope.list.ORIGINALTYPE == $scope.data.originList[i].value) {
                            $scope.checkOrigin($scope.data.originList[i]);
                            break;
                        }
                    }
                }
                // 原创声明
                $scope.oringin = function(list) {
                    if (list.ORIGINAL === '1') {
                        $scope.list.ORIGINAL = '0';
                        $scope.list.ORIGINALTYPE = '0';
                    } else {
                        $('.newsResourcesTips')
                            .find('.tips')
                            .remove();
                        $scope.list.ORIGINAL = '1';
                        $scope.list.ORIGINALTYPE = $scope.data.originList[0].value;
                        $scope.list.SPECIALDOC = 0;
                    }
                    if ($scope.status && !$scope.status.nopayment) {
                        $scope.status.nopayment = true;
                        $scope.list.ISNOPAYMENT = '0';
                    }
                };
                // 勾选原创稿二级单选的原创类型
                $scope.checkOrigin = function(item, type) {
                    $('.newsResourcesTips')
                        .find('.tips')
                        .remove();
                    $scope.list.ORIGINALTYPE = item.value;
                    $scope.list.ORIGINAL = '1';
                    $scope.list.SPECIALDOC = 0;
                    if (!$scope.status.nopayment && !!type) {
                        $scope.status.nopayment = true;
                        $scope.list.ISNOPAYMENT = '0';
                    }
                };
                // 点击特殊稿
                $scope.specialDoc = function() {
                    if ($scope.list.SPECIALDOC == 1) {
                        $scope.list.SPECIALDOC = 0;
                    } else {
                        $('.newsResourcesTips')
                            .find('.tips')
                            .remove();
                        $scope.list.SPECIALDOC = 1;
                        $scope.list.ORIGINAL = '0';
                        $scope.list.ORIGINALTYPE = '0';
                    }
                };

                // /**
                //  * [getSuggestions description]获取suggestion
                //  * @param  {[str]} viewValue [description]输入框内输入值
                //  * @return {[type]}           [description]
                //  */
                // $scope.getSuggestions = function(viewValue) {
                //     return editingCenterService.getRecentUsageSources(viewValue);
                // };
            },
        };
    },
]);
